<template>
    <c-dialog ref="dialog" title="资产档案详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.asset_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.asset_name}}</label>
                <c-state dict="assetStatusDic" tag :value="detailData.status"></c-state>
                <c-state dict="assetUseStatusDic" tag :value="detailData.current_status"></c-state>
                <c-state v-if="detailData.borrow_status == 1" dict="borrowStatusDic" tag :value="detailData.borrow_status"></c-state>
            </div>
        </template>

        <module>
            <module-col size="400">
                <c-detail class="m-detail-form">
                    <c-detail-item label="资产编号">
                        {{detailData.asset_code}}
                    </c-detail-item>
                    <c-detail-item label="资产名称">
                        {{detailData.asset_name}}
                    </c-detail-item>
                    <c-detail-item label="所属分类">
                        {{detailData.asset_category}}
                    </c-detail-item>
                    <c-detail-item label="单位">
                        {{detailData.unit_name}}
                    </c-detail-item>
                    <c-detail-item label="所属网点">
                        {{detailData.outlet_name}}
                    </c-detail-item>
                    <c-detail-item label="使用年限">
                        {{detailData.service_life_year}}年
                    </c-detail-item>
                    <c-detail-item label="资产图片" >
                        <c-file v-if="detailData.image_url" :src="detailData.image_url" width="150" height="150" fit="contain" media></c-file>
                        <span v-else>-</span>
                    </c-detail-item>

                    <c-detail-item label="资产描述">
                        {{detailData.asset_desc || '-'}}
                    </c-detail-item>
                    <c-detail-item label="附加资产描述">
                        {{detailData.sub_asset_desc || '-'}}
                    </c-detail-item>
                    <c-detail-item label="开始使用日期">
                        {{detailData.start_use_date || '-'}}
                    </c-detail-item>

                    <c-detail-item label="备注">
                        {{detailData.remark || '-'}}
                    </c-detail-item>
                    <c-detail-item label="借用状态">
                        <c-state v-if="detailData.borrow_status == 1" dict="borrowStatusDic" :value="detailData.borrow_status"></c-state>
                        <span v-else>-</span>
                    </c-detail-item>
                    <c-detail-item label="借用网点" >
                        {{detailData.borrow_outlet_name||'-'}}
                    </c-detail-item>
                    <c-detail-item label="最近领用人">
                        {{detailData.last_use_user||'-'}}
                    </c-detail-item>
                    <c-detail-item label="领用时间" >
                        {{detailData.last_use_time||'-'}}
                    </c-detail-item>

                    <c-detail-item label="创建人">
                        {{detailData.create_user_name}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <c-detail-item label="修改人">
                        {{detailData.update_user_name}}
                    </c-detail-item>
                    <c-detail-item label="修改时间">
                        {{detailData.update_date}}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="领用记录">
                    <div class="m-detail-box">
                        <c-table ref="receiveListTable" :data="receiveList" border :paging="true" :page-size="10">
                            <c-table-column label="状态" width="60">
                                <template #default="{data}">
                                    <c-state dict="applyStatusDic" :value="data.apply_status"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="领用单号" width="100">
                                <template #default="{data}">
                                    <c-link @click="globalDialog('assetReceiveApplyDetail', {props: {id: data.id}})">{{data.apply_code}}</c-link>
                                </template>
                            </c-table-column>

                            <c-table-column label="领用人" width="100">
                                <template #default="{data}">
                                    <span>{{data.apply_user_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="领用数量" width="100">
                                <template #default="{data}">
                                    <span>{{data.apply_quantity}}{{data.unit_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="计划使用时间" width="120">
                                <template #default="{data}">
                                    {{data.plan_use_time}}
                                </template>
                            </c-table-column>
                            <c-table-column label="计划归还时间" width="120">
                                <template #default="{data}">
                                    <span>{{data.plan_return_time}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="创建时间" width="120">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>


                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="归还记录">
                    <div class="m-detail-box">
                        <c-table ref="returnListTable" :data="returnList" border :paging="true" :page-size="10">
                            <c-table-column label="状态" width="60">
                                <template #default="{data}">
                                    <c-state dict="applyStatusDic" :value="data.apply_status"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="归还单号" width="150">
                                <template #default="{data}">
                                    <c-link @click="globalDialog('assetReturnDetail', {props: {id: data.id}})">{{data.apply_code}}</c-link>
                                </template>
                            </c-table-column>

                            <c-table-column label="归还人" width="100">
                                <template #default="{data}">
                                    <span>{{data.apply_user_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="归还数量" width="100">
                                <template #default="{data}">
                                    <span>{{data.return_count}}{{data.unit_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="归还时间" width="120">
                                <template #default="{data}">
                                    {{data.return_time}}
                                </template>
                            </c-table-column>

                            <c-table-column label="创建时间" width="120">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="借还记录">
                    <div class="m-detail-box">
                        <c-table ref="borrowListTable" :data="borrowList" border :paging="true" :page-size="10">
                            <c-table-column label="操作类型" width="100">
                                <template #default="{data}">
                                    <span v-if="data.operation_type == 1" style="color: brown">借用</span>
                                    <span v-if="data.operation_type == 2" style="color: green">归还</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="归属网点" width="150">
                                <template #default="{data}">
                                    <span>{{data.outlet_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="借用网点" width="150">
                                <template #default="{data}">
                                    <span>{{data.ref_outlet_name || '-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="操作人" width="120">
                                <template #default="{data}">
                                    <span>{{data.create_user_realname}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="操作时间" width="150">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="转移记录">
                    <div class="m-detail-box">
                        <c-table ref="transferListTable" :data="transferList" border :paging="true" :page-size="10">
                            <c-table-column label="原网点" width="150">
                                <template #default="{data}">
                                    <span>{{data.outlet_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="接收网点" width="150">
                                <template #default="{data}">
                                    <span>{{data.ref_outlet_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="操作人" width="120">
                                <template #default="{data}">
                                    <span>{{data.create_user_realname}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="操作时间" width="150">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>

                            <c-table-column label="备注" width="200">
                                <template #default="{data}">
                                    <span>{{data.remark || '-'}}</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="维修记录">
                    <div class="m-detail-box">
                        <c-table ref="repairListTable" :data="repairList" border :paging="true" :page-size="10">
                            <c-table-column label="状态" width="60">
                                <template #default="{data}">
                                    <c-state dict="repairStatusDic" :value="data.status"></c-state>
                                </template>
                            </c-table-column>

                            <c-table-column label="单据编号" width="150">
                                <template #default="{data}">
                                    <c-link @click="globalDialog('assetRepairRecordDetail', {props: {id: data.id}})">{{data.document_number}}</c-link>
                                </template>
                            </c-table-column>

                            <c-table-column label="维修类型" width="100">
                                <template #default="{data}">
                                    <c-state dict="repairTypeDic" :value="data.repair_type"></c-state>
                                </template>
                            </c-table-column>

                            <c-table-column label="送修人" width="100">
                                <template #default="{data}">
                                    <span>{{data.sender_user_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="送修时间" width="150">
                                <template #default="{data}">
                                    {{data.repair_time}}
                                </template>
                            </c-table-column>

                            <c-table-column label="完成时间" width="150">
                                <template #default="{data}">
                                    <span>{{data.finish_repair_time || '-'}}</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'fixedAssetDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            receiveList: [],
            returnList: [],
            borrowList: [],
            transferList: [],
            repairList: []
        }
    },

    computed: {
        ...mapState(['assetStatusDic', 'assetUseStatusDic', 'borrowStatusDic', 'applyStatusDic', 'repairTypeDic'])
    },

    methods: {
        open() {
            this.request({
                url: '/fixed_asset/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                    this.loadReceiveList();
                    this.loadReturnList();
                    this.loadBorrowList();
                    this.loadTransferList();
                    this.loadRepairList();
                    this.$refs.dialog.open();
                }
            });
        },

        loadReceiveList() {
            this.$refs.receiveListTable.load({
                url: '/asset_receive_apply/list',
                data: {
                    asset_id: this.id,
                    apply_status: [1, 2, 3, 4]
                },
                paging: true,
                pageSize: 10
            });
        },

        loadReturnList() {
            this.$refs.returnListTable.load({
                url: '/asset_return_apply/list',
                data: {
                    asset_id: this.id,
                    apply_status: [1, 2, 3, 4]
                },
                paging: true,
                pageSize: 10
            });
        },

        loadBorrowList() {
            this.$refs.borrowListTable.load({
                url: '/fixed_asset/operation/record/list',
                data: {
                    asset_id: this.id,
                    operation_types: [1, 2]
                },
                paging: true,
                pageSize: 10
            });
        },

        loadTransferList() {
            this.$refs.transferListTable.load({
                url: '/fixed_asset/operation/record/list',
                data: {
                    asset_id: this.id,
                    operation_types: [3]
                },
                paging: true,
                pageSize: 10
            });
        },

        loadRepairList() {
            this.$refs.repairListTable.load({
                url: '/asset_repair_record/list',
                data: {
                    asset_id: this.id
                },
                paging: true,
                pageSize: 10
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
